// Vue 2's light 300 body text, with bold kept at 700 (preflight's `bolder` would only reach 400) and raw HTML links
// styled like wiki links. Links inside locked, inert text keep its transparent colour so they stay blurred.
export const LIGHT_STRATEGY_TEXT =
  'font-[300] [&_:is(b,strong)]:font-bold [&_a:not([inert]_a)]:text-blue-600 [&_a:not([inert]_a)]:underline'
